export default __webpack_public_path__ + "static/SFMono-SemiboldItalic-9a0ae6382e12c5e28a7342ffb41cf4da.woff2";